import React from "react";
import Form from "../common/form";
import ProposalFormDetails from "./proposalFormDetails";
import ProposalFormDetails2 from "./proposalFormDetails2";
import ProposalConfirm from "./proposalConfirm";
import ProposalSuccess from "./proposalSuccess";
import {
  getInsertTypeForProgram,
  getPrimaryRegistrationValue,
  getRiskToleranceOptionsForProgram,
  shouldForceTaxableForRegistration,
} from "../../utils/proposalUtils";

export class ProposalForm extends Form {
  _isMounted = true;
  state = {
    step: 1,
    dateTime: "",
    data: {
      errorStatus: false,
      userName: "",
      program: "",
      clientName: "",
      advisorName: "",
      customTemplate: "",
      logo: "",
      riskTolerance: "",
      snapShot: "",
      papercheck: "true",
      othercheck: "",
      incomeNeeds: "",
      optionsTM: "",
      assetValue: "",
      logoSize: "",
      logoOffset: "",
      insertType: this.props.insertType ? this.props.insertType : "",
      fusionPercentage: 0,
      fusionAmount: 0,
      isNewFusionClient: true,
      fusionAccountNumbers: [],
    },
    registrations: [
      {
        registration: "registration0",
        value: "",
        percentage: "100",
      },
    ],
    proposalType: "",
  };

  componentDidMount = () => {
    var options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      currency: "USD",
      style: "currency",
      currencyDisplay: "symbol",
    };

    if (this.props.formRequestType === "NewSP") {
      this.setState({
        data: {
          errorStatus: false,
          userName: "",
          program: this.props.formProposalType,
          clientName: "",
          advisorName:
            this.props.fusion && this.props.fusionStepGuideData?.advisorName
              ? this.props.fusionStepGuideData.advisorName
              : "",
          customTemplate: "",
          logo: "",
          riskTolerance: "",
          snapShot: "",
          papercheck: "true",
          othercheck: "",
          incomeNeeds: "",
          optionsTM: "",
          assetValue: "",
          logoSize: "",
          logoOffset: "",
          insertType: this.props.insertType
            ? this.props.insertType
            : getInsertTypeForProgram(this.props.formProposalType),
          fusionPercentage: 0,
          fusionAmount: 0,
          isNewFusionClient: true,
          fusionAccountNumbers: [],
        },
        registrations: [
          {
            registration: "registration0",
            value: "",
            percentage: "100",
          },
        ],
        proposalType: this.props.formProposalType,
      });
    } else if (
      this.props.formRequestType === "Edit" ||
      this.props.formRequestType === "Copy"
    ) {
      this.setState({
        step: 1,
        dateTime:
          this.props.formRequestType === "Copy"
            ? ""
            : this.props.editProposal.DateTime
            ? this.props.editProposal.DateTime
            : "",
        data: {
          errorStatus: false,
          userName: "",
          program: this.props.editProposal.program,
          clientName: this.props.editProposal["CLIENT NAMES"],
          advisorName:
            this.props.fusion && this.props.fusionStepGuideData?.advisorName
              ? this.props.fusionStepGuideData.advisorName
              : this.props.editProposal["ADVISOR NAME"],
          customTemplate: this.props.editProposal.customTemplate,
          logo:
            this.props.editProposal["LOGO"] ===
            this.props.editProposal["ADVISOR NAME"]
              ? ""
              : this.props.editProposal["LOGO"],
          riskTolerance:
            this.props.editProposal["RISK TOLERANCE"] ??
            this.props.editProposal["embedded-excel"] ??
            this.props.editProposal["RISK"] ??
            "",
          snapShot: this.props.editProposal["insert-pdf"],
          papercheck: this.props.editProposal.papercheck
            ? String(this.props.editProposal.papercheck).toLowerCase() ===
              "true"
            : false,
          othercheck: this.props.editProposal.othercheck
            ? String(this.props.editProposal.othercheck).toLowerCase() ===
              "true"
            : false,
          incomeNeeds: this.props.editProposal.incomeNeeds != null
            ? this.props.editProposal.incomeNeeds.toLocaleString(undefined, options)
            : "",
          optionsTM: this.props.editProposal.optionsTM,
          assetValue: this.props.editProposal.assetValue,
          logoSize: this.props.editProposal.logoSize,
          logoOffset: this.props.editProposal.logoOffset,
          insertType: this.props.editProposal.insertType
            ? this.props.editProposal.insertType
            : getInsertTypeForProgram(this.props.editProposal.program),
          fusionPercentage: this.props.editProposal.fusionPercentage || 0,
          fusionAmount: this.props.editProposal.fusionAmount || 0,
          isNewFusionClient:
            this.props.editProposal.isNewFusionClient !== undefined
              ? this.props.editProposal.isNewFusionClient
              : true,
          fusionAccountNumbers:
            this.props.editProposal.fusionAccountNumbers || [],
        },
        registrations: this.getRegistrationsData(
          this.props.editProposal.registrations
        ),
        proposalType: this.props.editProposal.program,
      });
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  // Helper method to safely parse registrations data
  getRegistrationsData = (registrations) => {
    // Default registration structure
    const defaultRegistrations = [
      {
        registration: "registration0",
        value: "",
        percentage: "100",
      },
    ];

    // If no registrations data, return default
    if (!registrations) {
      return defaultRegistrations;
    }

    let parsedRegistrations = null;

    // If already an array (object), use it
    if (Array.isArray(registrations)) {
      parsedRegistrations = registrations;
    }
    // If it's a string, try to parse it
    else if (typeof registrations === "string") {
      try {
        const parsed = JSON.parse(registrations.replace(/'/g, '"'));
        parsedRegistrations = Array.isArray(parsed) ? parsed : null;
      } catch (error) {
        console.warn("Failed to parse registrations string:", registrations);
        return defaultRegistrations;
      }
    }
    // If it's some other object type, return default
    else {
      console.warn(
        "Unexpected registrations type:",
        typeof registrations,
        registrations
      );
      return defaultRegistrations;
    }

    // If we have parsed registrations and we're in Copy mode, validate them
    if (parsedRegistrations && this.props.formRequestType === "Copy") {
      // Get available registration types from props
      const availableRegistrationTypes = this.props.lists?.registrationTypes || [];

      // Validate each registration value
      const validatedRegistrations = parsedRegistrations.map((reg) => {
        // Check if the registration value exists in the current list
        const isValidValue = availableRegistrationTypes.some(
          (regType) => regType.name === reg.value
        );

        // If the value doesn't exist, reset it to blank
        if (!isValidValue && reg.value !== "") {
          console.warn(
            `Registration value "${reg.value}" no longer exists in registration types. Resetting to blank.`
          );
          return {
            ...reg,
            value: "", // Reset to blank/empty
          };
        }

        return reg;
      });

      return validatedRegistrations;
    }

    // For Edit mode or if no validation needed, return as-is
    return parsedRegistrations || defaultRegistrations;
  };

  // Proceed to the next step
  nextStep = () => {
    const { step } = this.state;

    // For Fusion workflow, navigate to fusion page after first step
    if (
      step === 2 &&
      this.state.proposalType &&
      this.state.proposalType.toLowerCase().includes("fusion")
    ) {
      // Pass collected data securely via state management if navigation function exists
      if (this.props.navigateToFusion) {
        this.props.navigateToFusion({ ...this.state.data, dateTime: this.state.dateTime });
        return;
      } else {
        // Default behavior: continue to step 3 if no navigation function provided
        console.warn(
          "navigateToFusion function not provided, continuing with normal flow"
        );
      }
    }

    this.setState({ step: step + 1 });
  };

  // Go back to previous step
  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  localStringToNumber(s) {
    return Number(String(s).replace(/[^0-9.-]+/g, ""));
  }

  handleChange = (input) => (e) => {
    let value = e.target.value;
    this.setState((prevState) => ({
      data: {
        ...prevState.data, // keep all other key-value pairs
        [input]: value, // update the value of specific key
      },
    }));
  };

  handleRegistrations = (input) => (e) => {
    const value = e.target.value;
    this.setState((prevState) => {
      const regList = prevState.registrations.map((registration) =>
        registration.registration === input
          ? { ...registration, value: value }
          : registration
      );

      const registrationTypes = this.props.lists?.registrationTypes || [];
      const selectedProgram = this.props.lists?.proposalTypes?.find(
        (proposalType) => proposalType.name === prevState.data.program
      );
      const shouldForceTaxable = shouldForceTaxableForRegistration(
        getPrimaryRegistrationValue(regList),
        registrationTypes
      );

      const nextData = { ...prevState.data };
      if (shouldForceTaxable) {
        nextData.optionsTM = "Taxable";
      }

      const availableRiskOptions = getRiskToleranceOptionsForProgram(
        selectedProgram,
        nextData.optionsTM || "Taxable",
        getPrimaryRegistrationValue(regList),
        registrationTypes
      );

      if (
        nextData.riskTolerance &&
        !availableRiskOptions.includes(nextData.riskTolerance)
      ) {
        nextData.riskTolerance = "";
      }

      return {
        registrations: regList,
        data: nextData,
      };
    });
  };

  handleAddRegistration = (input) => {
    let regList = [...this.state.registrations];
    regList.push({
      registration: String(input),
      value: "",
      percentage: "",
      // Add the value of a new specific key
    });
    this.setState({ registrations: regList });
  };

  handleRegistrationsPercentage = (input) => (e) => {
    const value = e.target.value;
    let regList = [...this.state.registrations];
    for (var r in regList) {
      if (regList[r].registration === input) {
        regList[r].percentage = value;
      }
    }
    this.setState({ registrations: regList });
  };

  handleChecked = (input) => (e) => {
    const value = e.target.checked;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [input]: value, // update the value of specific key
      },
    }));
    // if (e.target.checked && input === "othercheck") {
    //   let result = "";
    //   let BreakException = {};
    //   try {
    //     this.props.lists.advisors.forEach((element) => {
    //       if (String(element.Custom).toLowerCase() === "true") {
    //         result = element.Name;
    //         throw BreakException;
    //       }
    //     });
    //   } catch (error) {
    //     if (error !== BreakException) throw error;
    //   }
    //   this.handleDefault("advisorName", result);
    // } else if (!e.target.checked && input === "othercheck") {
    //   let result = "";
    //   let BreakException = {};
    //   try {
    //     this.props.lists.advisors.forEach((element) => {
    //       if (String(element.Custom).toLowerCase() === "true") {
    //         result = element.Name;
    //         throw BreakException;
    //       }
    //     });
    //   } catch (error) {
    //     if (error !== BreakException) throw error;
    //   }
    //   this.handleDefault("advisorName", "");
    //   this.handleDefault("customTemplate", result);
    // }
  };

  handleDefault = (input, value) => {
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [input]: value, // update the value of specific key
      },
    }));
    return value;
  };

  updateUserName = (input, value) => {
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [input]: value, // update the value of specific key
      },
    }));
  };

  updateProposalType = (type) => {
    this.setState({ proposalType: type });
  };

  render() {
    const handles = {
      handleChange: this.handleChange,
      handleChecked: this.handleChecked,
      handleDefault: this.handleDefault,
      handleAddRegistration: this.handleAddRegistration,
      handleRegistrations: this.handleRegistrations,
      handleRegistrationsPercentage: this.handleRegistrationsPercentage,
    };
    const { step, proposalType, dateTime, registrations } = this.state;

    const {
      errorStatus,
      userName,
      program,
      clientName,
      advisorName,
      logo,
      riskTolerance,
      snapShot,
      papercheck,
      othercheck,
      customTemplate,
      incomeNeeds,
      optionsTM,
      assetValue,
      logoSize,
      logoOffset,
      insertType,
      fusionPercentage,
      fusionAmount,
      isNewFusionClient,
      fusionAccountNumbers,
    } = this.state.data;
    const values = {
      errorStatus,
      userName,
      program,
      clientName,
      advisorName,
      logo,
      riskTolerance,
      snapShot,
      papercheck,
      othercheck,
      customTemplate,
      dateTime,
      registrations: JSON.parse(JSON.stringify(registrations)), // Deep copy to prevent shared references
      incomeNeeds,
      optionsTM,
      assetValue,
      logoSize,
      logoOffset,
      insertType,
      fusionPercentage,
      fusionAmount,
      isNewFusionClient,
      fusionAccountNumbers,
    };

    switch (step) {
      default:
        return (
          <ProposalFormDetails
            updateLastUpdateDate={this.props.updateLastUpdateDate}
            lastUpdateDate={this.props.lastUpdateDate}
            checkForUpdates={this.props.checkForUpdates}
            lists={this.props.lists}
            proposalType={proposalType}
            updateProposalType={this.updateProposalType}
            nextStep={this.nextStep}
            handles={handles}
            values={values}
            updateUserName={this.updateUserName}
            formRequestType={this.props.formRequestType}
            loggedIn={this.props.loggedIn}
            fusion={this.props.fusion}
            fusionProposals={this.props.fusionProposals}
            editIndex={this.props.editIndex}
          />
        );
      case 2:
        return (
          <ProposalFormDetails2
            registrations={registrations}
            handles={handles}
            lists={this.props.lists}
            proposalType={proposalType}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            values={values}
            fusion={this.props.fusion}
            formRequestType={this.props.formRequestType}
            totalFusionAmount={this.props.totalFusionAmount || 0}
            currentFusionTotal={this.props.currentFusionTotal || 0}
            addToFusion={this.props.addToFusion}
          />
        );
      case 3:
        return (
          <ProposalConfirm
            lists={this.props.lists}
            proposalType={proposalType}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            handles={handles}
            values={values}
          />
        );
      case 4:
        return (
          <ProposalSuccess
            proposals={this.props.lists.proposals}
            proposalType={proposalType}
            updateProposalType={this.updateProposalType}
            values={values}
          />
        );
    }
  }
}

export default ProposalForm;
